module.exports = __webpack_public_path__ + "img/photo-01.cd8b2292.png";